/* eslint-disable no-unneeded-ternary */
/* eslint-disable react/no-unknown-property */

/* eslint-disable react/jsx-indent */
import * as React from "react";

import {
  Backdrop,
  Fade,
  Grid,
  IconButton,
  makeStyles,
  Modal,
  useTheme,
} from "@material-ui/core";
import { Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import * as Yup from "yup";

import { me } from "../../../redux/slices/me";
import { setOpen } from "../../../redux/slices/organizationRegistation";
import { selectLoginOpen, setLogin } from "../../../redux/slices/publicSlice";
import { getApiService, postApiService } from "../../../services/AgapeAPI";
import RoundButton from "../../common/button/RoundButton";
import AgapeForm from "../../common/form/AgapeForm";
import AgapeIcon from "../../common/icons/AgapeIcon";
import BackModal from "../organizationRegistration/BackModal";
import useError from "../../../helpers/useError";

const useStyles = makeStyles((theme) => ({
  modal: {
    fontFamily: "Vazir-Bold",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    // maxWidth: '90vh',
    // overflowY: 'auto',
    maxHeight: "100vh",
    // overflowX: '',
    width: "98%",
    margin: "0 auto",
  },
  paper: {
    border: "2px solid #fff",
    borderRadius: "10px",
    boxShadow: theme.shadows[5],
    width: "100%",
    alignItems: "center",
    maxHeight: "100vh",
    justifyContent: "center",
    backgroundColor: "#f0f0f0",
    marginTop: "250px",
    overflow: "auto",
    overflowX: "hidden !important",
  },
  modalTitle: {
    backgroundColor: "#fff",
    padding: "20px",
    textAlign: "center",
    margin: "0",
    // marginTop: '10px',
  },
  titles: {
    textAlign: "center",
    textDecoration: "none",
    marginBottom: "0",
    clear: "both",
    fontSize: "4.5vw",
  },
  subTitle: {
    textAlign: "center",
    paddingBottom: "20px",
    fontSize: "3.5vw",
    clear: "both",
    fontFamily: "Vazir",
  },
  modalBody: {
    maxHeight: "90vh",
    clear: "both",
    marginBottom: "400px",
  },
  boxes: {
    color: "#505050",
    borderRadius: "10px",
    boxShadow: "0 1px 5px 0 rgba(10, 5, 74, 0.3)",
    paddingTop: "10px",
    paddingBottom: "10px",
    marginTop: "10px",
    marginBottom: "10px",
    textAlign: "center",
    "&:hover": {
      color: "#fff",
      backgroundColor: "#18c5bf",
    },
  },
  selectedBoxes: {
    borderRadius: "10px",
    boxShadow: "0 1px 5px 0 rgba(10, 5, 74, 0.3)",
    paddingTop: "10px",
    paddingBottom: "10px",
    marginTop: "10px",
    marginBottom: "10px",
    textAlign: "center",
    color: "#fff",
    backgroundColor: "#18c5bf",
  },
  area: {
    textAlign: "center",
    borderRadius: "10px",
    border: "0",
    backgroundColor: "#d0d0d0",
    maxWidth: "95%",
    display: "block",
    margin: "10px auto",
    minHeight: "100px",
    minWidth: "95%",
    maxHeight: "100px",
    fontSize: "4vw",
    padding: "10px 20px",
  },
  buttonC: {
    borderRadius: "10px",
    width: "100%",
  },
  iconBtn: {
    margin: "0px 10px 0 10px",
  },
  icons: {
    color: "red",
    fill: "#000",
    height: "40px",
    marginTop: "10px",
  },
  close: {
    textAlign: "left",
    // display: 'inline-block',
    float: "left",
    marginBottom: "20px",
    marginTop: "0",
  },
  boxesNo: {
    color: "#a0a0a0",
    borderRadius: "10px",
    boxShadow: "0 1px 5px 0 rgba(10, 5, 74, 0.3)",
    paddingTop: "10px",
    paddingBottom: "10px",
    marginTop: "10px",
    marginBottom: "10px",
    textAlign: "center",
    cursor: "not-allowed",
    backgroundColor: "#ddd",
    // '&:hover': {
    //   color: '#fff',
    //   backgroundColor: '#18c5bf',
    // },
  },
  container: {
    padding: "20px",
    paddingLeft: "50px",
  },
  buttonP: {
    width: "200px",
    margin: "20px auto",
    paddingRight: "50px",
  },
  // select: {
  //   width: '370px',
  //   display: 'block',
  // },
}));
// const iconName = ['building-solid', 'city', 'ios-people', 'people-circle'];
const fullWidth = true;
const star = true;
const isNumber = true;

const schema = Yup.object().shape({
  orgName: Yup.string()
    .required("وارد کردن نام سازمان اجباری میباشد")
    .min(5, "نام نمیتواند کمتر از 5 کارکتر باشد"),
  description: Yup.string()
    .nullable()
    .max(145, "توضیحات نمیتواند بیش از 145 کارکتر باشد"),
  phone: Yup.string()
    .nullable()
    .max(11, "شماره تلفن نمیتواند بیش از 11 کارکتر باشد"),
});

const Step1Mobile = (props) => {
  const dispatch = useDispatch();
  const user = useSelector(me);
  // const user = localStorage.getItem('user');
  const classes = useStyles();
  const theme = useTheme();

  const [states, setStates] = React.useState([]);
  const [cities, setCities] = React.useState([]);
  const [city, setCity] = React.useState("");
  const [state, setState] = React.useState("");
  const [num, forceUpdate] = React.useState(0);
  const login = useSelector(selectLoginOpen);

  const errorHook = useError();
  const setError = (err) => errorHook(err);

  React.useEffect(() => {
    setTimeout(() => {
      forceUpdate(num + 1);
    }, 1000);
  }, [login]);

  React.useEffect(() => {
    getState();
  }, []);

  React.useEffect(() => {
    if (state && state.value) {
      getCity();
    }
  }, [state]);

  const getState = () => {
    const statesPath = `countries/1/states`;
    const s = [];
    getApiService(statesPath)
      .then((res) => {
        res.data.forEach((e) => {
          s.push({ label: e.name, value: e.id });
        });
        setStates(s);
      })
      .catch((ex) => setError(ex));
  };
  const getCity = () => {
    const statesPath = `countries/1/states/${state.value}/cities`;
    const c = [];
    getApiService(statesPath)
      .then((res) => {
        res.data.forEach((e) => {
          c.push({ label: e.name, value: e.id });
        });
        setCities(c);
      })
      .catch((ex) => setError(ex));
  };

  return (
    <BackModal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        onClose={() => {
          dispatch(setOpen(false));
        }}
        open={1}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 1000,
        }}
      >
        <Fade in={1}>
          <div className={classes.paper}>
            <h1 className={classes.modalTitle}>
              <IconButton
                className={classes.close}
                onClick={() => {
                  dispatch(setOpen(false));
                }}
              >
                <AgapeIcon icon="close" size="1.5rem" />
              </IconButton>
              میخواهم سازمان اجتماعی معرفی کنم
            </h1>
            <div className={classes.modalBody}>
              <Grid
                container
                className={classes.container}
                alignItems="center"
                justifyContent="center"
              >
                <Grid item md={12}>
                  <Formik
                    initialValues={{
                      orgName: "",
                      state: "",
                      city: "",
                      phone: "",
                      description: "",
                    }}
                    validationSchema={schema}
                    onSubmit={(values, { setSubmitting }) => {
                      if (user) {
                        const d = {
                          name: values.orgName,
                          description: values.description,
                          phone: values.phone,
                          state_id: state.value,
                          city_id: city.value,
                        };
                        postApiService("ums/organization-introduces", d)
                          .then(() => {
                            toast.success("عملیات با موفقیت انجام شد");
                            dispatch(setOpen(false));
                          })
                          .catch((ex) => {
                            setError(e);
                          });
                      } else {
                        dispatch(setLogin(true));
                      }
                    }}
                  >
                    {({
                      values,
                      errors,
                      isSubmitting,
                      isValid,
                      handleSubmit,
                      handleChange,
                      handleBlur,
                      handleReset,
                      setFieldValue,
                      validateField,
                    }) => (
                      <>
                        <AgapeForm
                          colXs={12}
                          publics
                          fields={[
                            {
                              name: "orgName",
                              errors: errors.orgName,
                              star,
                              fullWidth,
                              label: "عنوان سازمان اجتماعی",
                              placeholder: "عنوان سازمان را وارد کنید",
                              value: values.orgName,
                              onChange: handleChange,
                            },
                            {
                              name: "state",
                              errors: errors.state,
                              star,
                              fullWidth,
                              label: "استان سازمان",
                              placeholder: "استان سازمان را انتخاب کنید",
                              value: state,
                              type: "select",
                              onChange: (e) => setState(e),
                              options: states,
                              className: classes.select,
                            },
                            {
                              name: "city",
                              errors: errors.city,
                              star,
                              fullWidth,
                              label: "شهر سازمان",
                              placeholder: "شهر سازمان را انتخاب کنید",
                              value: city,
                              type: "select",
                              onChange: (e) => setCity(e),
                              options: cities,
                              disabled: cities.length < 1,
                              className: classes.select,
                            },
                            {
                              name: "phone",
                              errors: errors.phone,
                              isNumber,
                              fullWidth,
                              label: "شماره تماس سازمان",
                              placeholder: "09213785159",
                              value: values.phone,
                              onChange: handleChange,
                            },
                            {
                              name: "description",
                              errors: errors.description,
                              type: "textarea",
                              fullWidth,
                              label: "",
                              placeholder: "توضیحاتی بنویسید",
                              value: values.description,
                              onChange: handleChange,
                            },
                          ]}
                        />
                        <Grid item xs={12}>
                          <div className={classes.buttonP}>
                            <RoundButton
                              disabled={
                                errors?.orgName ||
                                errors?.phone ||
                                errors?.description ||
                                state === "" ||
                                city === ""
                              }
                              onClick={handleSubmit}
                              type="submit"
                              customClassName={classes.buttonC}
                              hoverBackgroundColor={theme.palette.primary.main}
                            >
                              {" معرفی "}
                            </RoundButton>
                          </div>
                        </Grid>
                      </>
                    )}
                  </Formik>
                </Grid>
              </Grid>
            </div>
          </div>
        </Fade>
      </Modal>
    </BackModal>
  );
};

export default Step1Mobile;
